import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

const EndResultPules = React.memo(({ pules, myPos, t }) => {
  let player1Pules = 0;
  let player2Pules = 0;
  let player3Pules = 0;

  console.log('EndResultPules pules', pules);

  Object.keys(pules).map((key) => {
    if (pules[key] && pules[key].status === 'active') {
      if (pules[key].player === 'player1') {
        player1Pules = player1Pules + 1;
      } else if (pules[key].player === 'player2') {
        player2Pules = player2Pules + 1;
      } else if (pules[key].player === 'player3') {
        player3Pules = player3Pules + 1;
      }
    }
  })

    return (
      <table className="score-table-sum">
        <thead />
        <tbody style={{ width: '100%' }}>
          <tr>
            <th className="score-table-sum-col-id">
              <div>
                {t('activePules')}
              </div>
            </th>
            <th className="score-table-points-col">
              <>
                {myPos === 'player1' && (
                  <>
                    {player2Pules}
                  </>
                )}
                {myPos === 'player2' && (
                  <>
                    {player3Pules}
                  </>
                )}
                {myPos === 'player3' && (
                  <>
                    {player1Pules}
                  </>
                )}
              </>
            </th>
            <th className="score-table-points-col">
              <>
                {myPos === 'player1' && (
                  <>
                    {player1Pules}
                  </>
                )}
                {myPos === 'player2' && (
                  <>
                    {player2Pules}
                  </>
                )}
                {myPos === 'player3' && (
                  <>
                    {player3Pules}
                  </>
                )}
              </>
            </th>
            <th className="score-table-points-col">
              <>
                {myPos === 'player1' && (
                  <>
                    {player3Pules}
                  </>
                )}
                {myPos === 'player2' && (
                  <>
                    {player1Pules}
                  </>
                )}
                {myPos === 'player3' && (
                  <>
                    {player2Pules}
                  </>
                )}
              </>
            </th>
            <th className="score-table-sum-col-pules" />
          </tr>
        </tbody>
      </table>
    );
});

EndResultPules.propTypes = {
  currentTable: PropTypes.arrayOf(PropTypes.shape()),
  cardsAdded: PropTypes.shape(),
  myPos: PropTypes.string,
};

EndResultPules.defaultProps = {
  currentTable: [],
  cardsAdded: {},
  myPos: '',
};

const mapStateToProps = (state, ownProps) => {
  if (state.game) {
    return ({
      pules: state.points.pules || {},
      myPos: state.game.myPos || null,
    });
  } else {
    return null;
  }
};

export default connect(mapStateToProps, null)(EndResultPules);
